export const SERVICE = 'SERVICE';
export const SOFTWARE = 'SOFTWARE';